import { createStyles } from 'antd-style';
export var useStyles = createStyles(function () {
  return {
    item: {
      '&:hover': {
        background: '#F5F7FA',
        opacity: '1'
      },
      display: 'block',
      height: '100%'
    }
  };
});